module.exports = __webpack_public_path__ + "img/ProductBanner.d22573bc.png";